import {PortfolioDataType} from '@crema/types/models/extrapages/Portfolio';

export const portfolioData: PortfolioDataType = {
  portfolio: {
    all: [
      {
        id: 1,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio1.png',
        title: 'Potato Oslands',
        subTitle: 'Logos',
      },
      {
        id: 2,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio2.png',
        title: 'Potato Oslands',
        subTitle: 'Branding',
      },
      {
        id: 3,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio3.png',
        title: 'Potato Oslands',
        subTitle: 'Logos',
      },
      {
        id: 4,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio4.png',
        title: 'Potato Oslands',
        subTitle: 'Logos',
      },
      {
        id: 5,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio5.png',
        title: 'Potato Oslands',
        subTitle: 'Branding',
      },
      {
        id: 6,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio6.png',
        title: 'Potato Oslands',
        subTitle: 'Graphics',
      },
      {
        id: 7,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio7.png',
        title: 'Potato Oslands',
        subTitle: 'Branding',
      },
      {
        id: 8,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio8.png',
        title: 'Potato Oslands',
        subTitle: 'Graphics',
      },
    ],
    branding: [
      {
        id: 1,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio2.png',
        title: 'Potato Oslands',
        subTitle: 'Branding',
      },
      {
        id: 2,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio5.png',
        title: 'Potato Oslands',
        subTitle: 'Branding',
      },
      {
        id: 3,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio7.png',
        title: 'Potato Oslands',
        subTitle: 'Branding',
      },
    ],
    graphics: [
      {
        id: 1,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio6.png',
        title: 'Potato Oslands',
        subTitle: 'Graphics',
      },
      {
        id: 2,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio8.png',
        title: 'Potato Oslands',
        subTitle: 'Graphics',
      },
    ],
    logos: [
      {
        id: 1,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio1.png',
        title: 'Potato Oslands',
        subTitle: 'Logos',
      },
      {
        id: 2,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio3.png',
        title: 'Potato Oslands',
        subTitle: 'Logos',
      },
      {
        id: 3,
        srcImg: '/assets/images/extra-pages/portfolio/portfolio4.png',
        title: 'Potato Oslands',
        subTitle: 'Logos',
      },
    ],
  },
  portfolioDetail: {
    product: [
      {
        id: 1,
        srcImg: '/assets/images/extra-pages/portfolio/product1.png',
      },
      {
        id: 2,
        srcImg: '/assets/images/extra-pages/portfolio/product2.png',
      },
      {
        id: 3,
        srcImg: '/assets/images/extra-pages/portfolio/product3.png',
      },
      {
        id: 4,
        srcImg: '/assets/images/extra-pages/portfolio/product4.png',
      },
    ],
    premiumBrand: {
      srcImg: '/assets/images/extra-pages/portfolio/plate.png',
      subTitle: 'Premium lifestyle brand',
      title: 'Fresh look book 2021',
    },
    innovation: {
      srcImg: '/assets/images/extra-pages/portfolio/innovation.png',
      brandSubTitle: 'Different design',
      brandTitle: 'Branding strategy and innovation',
      title: 'We design experiences that make a difference',
      description:
        'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit.',
    },
    slide: [
      {
        id: 1,
        srcImg: '/assets/images/extra-pages/portfolio/slide1.png',
      },
      {
        id: 2,
        srcImg: '/assets/images/extra-pages/portfolio/slide1.png',
      },
      {
        id: 3,
        srcImg: '/assets/images/extra-pages/portfolio/slide1.png',
      },
      {
        id: 4,
        srcImg: '/assets/images/extra-pages/portfolio/slide1.png',
      },
      {
        id: 5,
        srcImg: '/assets/images/extra-pages/portfolio/slide1.png',
      },
    ],
    projectDescription: {
      service: [
        {
          id: 1,
          title: 'Published',
          subTitle: '20 January 2020',
        },
        {
          id: 2,
          title: 'Services',
          subTitle: 'Branding',
        },
        {
          id: 3,
          title: 'Industry',
          subTitle: 'Lifestyle',
        },
      ],
      content: [
        {
          id: 1,
          line: 'Lorem ipsum is simply dummy text of the printing and typesetting industry. lorem ipsum has been the industrys standard dummy text ever since when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries but also leap into typesetting.',
        },
        {
          id: 2,
          line: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.',
        },
        {
          id: 3,
          line: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
        },
        {
          id: 4,
          line: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta...',
        },
      ],
    },
  },
};

export default portfolioData;
